<template>
<z-table
  ref="dataTable"
  :columns="columns"
  :data="formatList"
  :pagination="pagination"
  selected-style
  class="no-wrapper-table"
/>
</template>

<script>
import unitConverter from '../../../utils/unitConverter'
import ZTableColumn from '../../06Data-Management/02Normal/08VOCs-Data-Compare/ZTableColumn'
import ZTable from '../../06Data-Management/02Normal/08VOCs-Data-Compare/ZTable'
import ZTablePagination from '../../06Data-Management/02Normal/08VOCs-Data-Compare/ZTablePagination'

export default {
  name: 'Table',
  components: {ZTable},
  props: {
    list: {
      required: true,
      type: Array
    },
    columnMap: {
      required: true,
      type: Object
    },
    pagination: {
      required: true,
      type: ZTablePagination
    }
  },
  data: () => ({
    columns: Object.freeze([]),
    factorColumns: Object.freeze([])
  }),
  computed: {
    formatList () {
      let {columnMap} = this

      return Object.values(this.list.reduce((map, data) => {
        let {factorId} = data
        let factor = columnMap[factorId]

        if (factor) {
          let {dataTime} = data
          let newData = map[dataTime]

          if (!newData) {
            newData = map[dataTime] = {
              dataTime
            }
          }

          newData[data.factorId] = Number(unitConverter(data.value, factor.unit, factor.displayUnit, factor.molecular).toFixed(factor.digitalCount))
        }

        return map
      }, {}))
    }
  },
  watch: {
    formatList: {
      immediate: true,
      handler () {
        let factorColumns = this.factorColumns = Object.freeze(Object.values(this.columnMap).map(({id, name, displayUnit}) => Object.freeze(new ZTableColumn({
          label: `${name}${displayUnit ? `(${displayUnit})` : ''}`,
          prop: id
        }))))

        this.columns = Object.freeze([
          Object.freeze(new ZTableColumn({
            label: '时间',
            prop: 'dataTime',
            align: 'center',
            width: 170,
            fixed: true
          })),
          ...factorColumns
        ])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.no-wrapper-table {
  /deep/ {
    th,
    td {
      white-space: nowrap !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/07Env/02History/Table.vue